import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import { VueReCaptcha } from 'vue-recaptcha-v3'
import CKEditor from 'ckeditor4-vue'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(CKEditor)

// Composition API
Vue.use(VueCompositionAPI)

// Vue recaptcha
Vue.use(VueReCaptcha, {
  siteKey: '6LcxRQQpAAAAALNKf4_5NwrfY70tjGuY6aZwbd-8',
  loaderOptions: {
    autoHideBadge: true,
  },
})

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
